import * as types from './actionTypes/docs';
import docAPI from '../../data/doc-api';
import { startLoading, endLoading } from './loading-actions';
import RequiredDocument_ from '../../data/models/RequiredDocumet';

export interface IRequiredDocumentActionType {
  type: typeof types.GET_ACTIVE_REQUIRED_DOCUMENTS_SUCCESS |
  typeof types.GET_ACTIVE_REQUIRED_DOCUMENTS_FAIL;
  payload: RequiredDocument_[];
}

export interface IRequiredDocumentHistoryActionType {
  type: typeof types.GET_REQUIRED_DOCUMENTS_HISTORY_SUCCESS |
  typeof types.GET_REQUIRED_DOCUMENTS_HISTORY_FAIL;
  payload: RequiredDocument_[];
}

export const getRequiredDocumentsSuccess = (data: RequiredDocument_[]) => {
  return { type: types.GET_ACTIVE_REQUIRED_DOCUMENTS_SUCCESS, payload: data, error: false, };
};
function getRequiredDocumentsFail(error: string) {
  (window as any).errorManager.captureException(error, true);
  return { type: types.GET_ACTIVE_REQUIRED_DOCUMENTS_FAIL, payload: error, error: true, };
}
export const getRequiredDocuments = () => async dispatch => {
  dispatch(startLoading());

  try {
    const response = await docAPI.getRequiredDocuments();

    dispatch(endLoading());

    return response.errorCode > 0
      ? dispatch(getRequiredDocumentsFail(response.message))
      : dispatch(getRequiredDocumentsSuccess(response.result));
  } catch (ex: any) {
    dispatch(endLoading());

    return dispatch(getRequiredDocumentsFail(ex));
  }
};

function getRequiredDocumentsHistorySuccess(data) {
  return { type: types.GET_REQUIRED_DOCUMENTS_HISTORY_SUCCESS, payload: data, error: false, };
}
function getRequiredDocumentsHistoryFail(error) {
  return { type: types.GET_REQUIRED_DOCUMENTS_HISTORY_FAIL, payload: error, error: true, };
}
export const getRequiredDocumentsHistory = () => async dispatch => {
  dispatch(startLoading());

  try {
    const { errorCode, message, result, } = await docAPI.getRequiredDocumentsHistory();
    dispatch(endLoading());
    return errorCode > 0
      ? dispatch(getRequiredDocumentsHistoryFail(message))
      : dispatch(getRequiredDocumentsHistorySuccess(result));
  } catch (ex) {
    dispatch(endLoading());

    return dispatch(getRequiredDocumentsHistoryFail(ex));
  }
};
